/** @jsx jsx */
import { jsx } from "theme-ui"
import Spacer from "@components/Spacers"

const Section = ({ children, noPt, noPb, smallSpacer, mediumSpacer, ...props }) => {
  let spacer = <Spacer.Large />

  if (smallSpacer) {
    spacer = <Spacer.Small />
  }
  if (mediumSpacer) {
    spacer = <Spacer.Medium />
  }

  return (
    <section {...props}>
      {!noPt && spacer}
      {children}
      {!noPb && spacer}
    </section>
  )
}

export default Section
